// Adapted from webapp scoring/levenshtein.js

export const getDistance = (
  correctAnswer: string,
  userAnswer: string,
): number => {
  const distanceMatrix = calculateDistanceMatrix(
    userAnswer,
    correctAnswer,
  );

  // The algorithm guarantees that the best distance will be stored
  // in the last square on the matrix, due to minimization.
  return distanceMatrix[userAnswer.length][correctAnswer.length];
};

const calculateDistanceMatrix = (a: string, b: string): number[][] => {
  const distanceMatrix = createDistanceMatrix(a, b);
  const itemAt = getItemAt();

  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      const is_correct = itemAt(a, i - 1) === itemAt(b, j - 1);

      distanceMatrix[i][j] = Math.min(
        distanceMatrix[i - 1][j] + 1,
        distanceMatrix[i][j - 1] + 1,
        distanceMatrix[i - 1][j - 1] + (is_correct ? 0 : 1),
      );
    }
  }

  return distanceMatrix;
};

const createDistanceMatrix = (a: string, b: string): number[][] => {
  const distanceMatrix: number[][] = [];
  for (let i = 0; i <= a.length; i += 1) {
    distanceMatrix[i] = [];
    distanceMatrix[i][0] = i;
  }
  for (let j = 0; j <= b.length; j += 1) {
    distanceMatrix[0][j] = j;
  }
  return distanceMatrix;
};

type GetItemType = (s: string, pos: number) => string;

const getItemAt = (): GetItemType => {
  return (s, pos) => {
    return s.charAt(pos);
  };
};
